import { render, staticRenderFns } from "./UpdateUserDetailsForm.vue?vue&type=template&id=2cbbd30f&scoped=true&"
import script from "./UpdateUserDetailsForm.vue?vue&type=script&lang=js&"
export * from "./UpdateUserDetailsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cbbd30f",
  null
  
)

export default component.exports